import Lottie from 'react-lottie';
import React from 'react';
import * as animationData from './loader.json';

const Animation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  };
  return <Lottie options={defaultOptions} height={400} width={400} />;
};

export default Animation;
